<template>
  <div class="main mx-auto max-w-cont-md lg:max-w-cont-lg mt-8 lg:mt-0">
    <div class="inner-cont px-[24px] lg:px-8">
      <h1 id="title" tabindex="-1" class="lg:pt-2 mb-8 lg:mb-6 text-h1home-mob md:text-h1home text-purple">{{ appData.home.title }}</h1>
      <div class="max-w-[51.875rem] mx-auto">
        <p id="intro" class="mb-8 lg:mb-6 text-phome-mob lg:text-p">{{ appData.home.intro }}</p>
        <p id="begin" class="mb-8 lg:mb-6 text-h2-mob md:text-h2home text-purple">{{ appData.home.begin }}</p>
      </div>
    </div>
    <div class="inner-cont2 sm:px-[24px] lg:px-8">
      <div class="flex flex-col lg:flex-row gap-y-4 lg:gap-y-0 lg:gap-x-4 lg:gap-x-6">
          <RouterLink to="/alcohol" class="group">
            <div id="alcohol" class="bg-[#612B78] p-4 md:p-5 lg:p-7 rounded-20px lg:rounded-50px flexmk flex-col items-center lg:block">
              <div class="grow-0 lg:max-w-none lg:w-full">
                <div class="home-img">
                  <img src="@/assets/img/alcohol_th.jpg" alt="" />
                </div>
              </div>
              <div class="grow-0 flex flex-col justify-center lg:block lg:w-full">
                <h2 class="mb-4 lg:mb-8 text-h2home-mob md:text-h2home text-white">{{ appData.home.alcohol }}</h2>
                <div v-on:click="gaEvent('alcohol')" class="main-btn" :aria-label=" appData.start + ' - ' + appData.home.alcohol">{{ appData.start }}</div>
              </div>
            </div>
          </RouterLink>
          <RouterLink to="/vaping" class="group">
            <div id="nicotine" class="bg-[#532D7D] p-4 md:p-5 lg:p-7 rounded-20px lg:rounded-50px flexmk flex-col items-center block">
              <div class="grow-0 lg:w-full">
                <div class="home-img">
                  <img src="@/assets/img/nicotine_th.jpg" alt=""/>
                </div>
              </div>
              <div class="grow-0 flex flex-col justify-center lg:block lg:w-full">
                <h2 class="mb-4 lg:mb-8 text-h2home-mob md:text-h2home text-white">{{ appData.home.nicotine }}</h2>
                <div v-on:click="gaEvent('nicotine')" class="main-btn" :aria-label=" appData.start + ' - ' + appData.home.nicotine">{{ appData.start }}</div>
              </div>
            </div>
          </RouterLink>
          <RouterLink to="/cannabis" class="group">
            <div id="cannabis" class="bg-[#442E82] p-4 md:p-5 lg:p-7 rounded-20px lg:rounded-50px flexmk flex-col items-center block">
              <div class="grow-0 lg:max-w-none lg:w-full">
                <div class="home-img">
                  <img src="@/assets/img/cannabis_th.jpg" alt=""/>
                </div>
              </div>
              <div class="grow-0 flex flex-col justify-center lg:block lg:w-full">
                <h2 class="mb-4 lg:mb-8 text-h2home-mob md:text-h2home text-white">{{ appData.home.cannabis }}</h2>
                <div v-on:click="gaEvent('cannabis')" class="main-btn" :aria-label=" appData.start + ' - ' + appData.home.cannabis">{{ appData.start }}</div>
              </div>
            </div>
          </RouterLink>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'

export default {
  name: 'HomeView',
  props: {
    appData: {},
    lang: ''
  },
  // components: {
  //   HelloWorld
  // },
  mounted: function(){
    // console.log('ad',this.appData)
    lastRecordedState = ['homepage'];
    var tl = gsap.timeline({delay: 0});
    tl.from("#title", {opacity: 0, duration: 0, ease: "power2.in"})
    .from("#intro", {y: -30, opacity: 0, duration: 0, ease: "power2.inOut"},"-=.1")
    .from("#begin", {y: -10, opacity: 0, duration: 0, ease: "power2.inOut"},"-=.2")
    .from("#alcohol", {opacity: 0, duration: 0, ease: "power2.in"},"-=.3")
    .from("#nicotine", {opacity: 0, duration: 0, ease: "power2.in"},"-=.3")
    .from("#cannabis", {opacity: 0, duration: 0, ease: "power2.in"},"-=.3");
    document.querySelector('h1').focus()
    // var tl = gsap.timeline({delay:.1});
    // tl.from("#title", {opacity: 0, duration: .7, ease: "power2.in"})
    // .from("#intro", {y: -30, opacity: 0, duration: .7, ease: "power2.inOut"},"-=.1")
    // .from("#begin", {y: -10, opacity: 0, duration: .7, ease: "power2.inOut"},"-=.2")
    // .from("#alcohol", {opacity: 0, duration: .5, ease: "power2.in"},"-=.3")
    // .from("#nicotine", {opacity: 0, duration: .5, ease: "power2.in"},"-=.3")
    // .from("#cannabis", {opacity: 0, duration: .5, ease: "power2.in"},"-=.3");
  },
  methods: {
    gaEvent: function(val){
      var dataLayer = window.dataLayer || [];
      var ln = this.lang
      if(ln == 'F'){
        ln = 'FR'
      }else{
        ln = 'EN'
      }
      //console.log(val,ln)
      dataLayer.push({
          'event': 'pressure-points_activity-state',
          'ppa_activity': 'Pressure Points',
          'ppa_game': val,
          'ppa_lang': ln,
          'ppa_status': 'started'
      });
    }
  }
}
</script>

w-100 rounded-[30px] overflow-hidden

<style scoped>
  .home-img{
    /* width: 100%; */
    overflow: hidden;
    border: 3px solid white;
    border-radius: 30px;
    margin-bottom: 20px;
  }


</style>